export const pricingPlans = [
  {
    name: "Starter Package",
    subtitle: "For freelancers & small teams",
    icon: "starter",
    price: "175",
    originalPrice: "250",
    discount: "Save 30%",
    currency: "Dh",
    annualPrice: "2,100",
    features: [
      {
        text: "2 requests/month",
        subtext: "+ Dh 100 per additional"
      },
      "3 months freeze per year",
      "Unlimited employee support",
      "Online dashboard access",
      "Government slip tracking",
      "Dh 100 additional/request for savings below government centre fees"
    ],
    buttonText: "Select Plan",
    buttonColor: "dark",
    popular: false
  },
  {
    name: "Growth Package",
    subtitle: "For scaling businesses",
    icon: "growth",
    price: "350",
    originalPrice: "500",
    discount: "Save 30%",
    currency: "Dh",
    annualPrice: "4,200",
    features: [
      {
        text: "5 requests/month",
        subtext: "+ Dh 100 per additional"
      },
      "3 months freeze per year",
      "Express delivery (Dh 100)",
      "Unlimited employee support",
      "Semi-dedicated account manager",
      "Government slip tracking",
      "24/7 online support",
      "Dh 100 additional/request for savings below government centre fees"
    ],
    buttonText: "Select Plan",
    buttonColor: "white",
    popular: true
  },
  {
    name: "PRO Package",
    subtitle: "For enterprises & high-volume needs",
    icon: "pro",
    price: "750",
    originalPrice: "1,000",
    discount: "Save 25%",
    currency: "Dh",
    annualPrice: "9,000",
    features: [
      {
        text: "10 requests/month",
        subtext: "+ Dh 75 per additional"
      },
      "Unlimited features in app",
      "Dedicated relationship manager",
      "Priority express delivery (Dh 75)",
      "Priority SLA support",
      "Unlimited employee support",
      "6 months freeze per year (no cost)",
      "White-glove concierge service",
      "Compliance advisory included",
      "Tax consultation included",
      "Government slip tracking",
      "Custom reporting & analytics",
      "24/7 premium support with 1-hour response time",
      "Dh 100 additional/request for savings below government centre fees"
    ],
    buttonText: "Select Plan",
    buttonColor: "gradient",
    popular: false
  }
];
